// src/pages/NewsletterPage.jsx
import React from 'react';
import Footer from '../components/Footer';
import MailchimpFormEmbed from '../components/MailchimpFormEmbed';
import './NewsletterPage.css';

const NewsletterPage = () => {
  const benefits = [
    {
      bold: 'Data-driven reports',
      text: 'New findings and knowledge articles as soon as they publish.',
    },
    {
      bold: 'Opportunities',
      text: 'Engage with Nexed Insight research and networks.',
    },
    {
      bold: 'Community',
      text: 'Join experts as passionate about business education as you are.',
    },
    {
      bold: 'Maximize & Optimize',
      text: 'Increase learning strategy effectiveness, optimize budgets, and unearth new solutions.',
    },
    {
      bold: 'Innovation & Best Practice',
      text: 'Explore emerging methodologies, technologies, approaches, and concepts.',
    },
    {
      bold: 'Impact & ROI',
      text: 'Actionable insights to measure and prove real-world impact.',
    },
  ];

  return (
    <>
      <div className="page-container newsletter-page-container">
        <header className="newsletter-page-header">
          <h1>Join Our Network for Deeper Understanding, Smarter Decisions, and Greater Impact.</h1>
          <p>Become part of a global community of innovators and strategic thinkers.</p>
        </header>

        <section className="newsletter-content-section">
          {/* Left column: "What You'll Get" section */}
          <div className="newsletter-copy">
            <h2 className="section-title">What you'll get</h2> {/* Added class for specific styling */}
            <p className="section-subtitle">
              A global community of innovators and strategic thinkers from across the business-education ecosystem.
            </p>

            <div className="newsletter-benefits-grid"> {/* New wrapper for grid */}
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item">
                  <i className="fa-regular fa-square-check"></i>
                  <div className="benefit-text-content">
                    <strong>{benefit.bold}</strong> {benefit.text}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right column: Mailchimp embed form */}
          <div className="newsletter-form-container">
            <h2 className="form-title">Join the network today</h2> {/* Added class for specific styling */}
            {/* MailchimpFormEmbed now handles the form structure */}
            <MailchimpFormEmbed />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default NewsletterPage;